(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDialogController', MoneyTransferLogDialogController);

    MoneyTransferLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.moneyTransferLog.id !== null) {
                MoneyTransferLog.update(vm.moneyTransferLog, onSaveSuccess, onSaveError);
            } else {
                MoneyTransferLog.save(vm.moneyTransferLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:moneyTransferLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.transferDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
